import AddBox from "@mui/icons-material/AddBox";
import { Button, CardContent, Grid, styled } from "@mui/material";
import { useMemo, useState } from "react";
// Components
import { IBooking } from "@vmosolutions/oc-interfaces";
import { FilterSearchTable } from "src/components/FilterSearchTable/FilterSearchTable";
import { BookingForm, initialValues } from "../Forms/BookingForm";
// Redux
import { ITableColumn } from "src/components/FilterSearchTable/TableComponents/TableHeader";

interface IManageProps {
  path?: string[];
  id?: string;
  tableMaxHeight?: number;
}

const OCManageBookings = styled(CardContent)(({ theme }) => ({
  flexGrow: 1,
  height: "100%",
  position: "relative",
  "& .booking_display_table": {
    maxWidth: 900,
  },
  "& .booking_actions, & .hotel_actions": {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    "& button.action_btn": {
      borderRadius: 2,
      fontSize: 11,
      fontWeight: 300,
      padding: "0px 10px 0px",
      minWidth: 20,
      "& svg": {
        width: 16,
        height: 16,
        margin: 5,
      },
    },
  },
}));

// PAIRINGS
const bookingsTableDesc = {
  tableTitle: "",
  tableDescription: "",
  noMessage: "No bookings to display, use the filters above to search.",
};
const bookingsTableInfo: ITableColumn[] = [
  {
    id: "_id",
    value: "_id",
    index: 0,
    numeric: true,
    label: "Booking ID",
    type: "string",
    width: 10,
    visible: false,
    filter: false,
  },
  {
    id: "agency[title]",
    value: "agency[title]",
    index: 1,
    numeric: true,
    label: "Booking Agency",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "locator",
    value: "locator",
    index: 2,
    numeric: true,
    label: "Locator",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "component",
    value: "component",
    index: 3,
    numeric: true,
    label: "Booking",
    type: "object",
    width: 10,
    visible: true,
    filter: false,
  },
  {
    id: "associatedPairings",
    value: "associatedPairings",
    index: 4,
    numeric: true,
    label: "Pairings",
    type: "object",
    width: 10,
    visible: true,
    filter: false,
  },
];

// Function used to create the dataSet needed for the table component.
export const tableData: any = [
  {
    id: "bookings",
    dataType: "bookings",
    label: "Bookings",
    data: [],
    tableInfo: bookingsTableInfo,
    tableInfoDisplay: bookingsTableDesc,
  },
];

/**
 * Manage Crew Travel Bookings.
 */
export const ManageBookings = (props: IManageProps): JSX.Element => {
  const { id, path, tableMaxHeight } = props;
  const mosaicPanel = useMemo(() => `${id}-panel`, [id]);
  const [initialFormValues, setInitialFormValues] = useState<IBooking>(null);

  return (
    <OCManageBookings>
      <Grid container direction="column">
        <Grid item className="booking_actions">
          <Grid container direction="row">
            <Button
              className="action_btn"
              disabled={initialFormValues && !initialFormValues._id}
              onClick={() => setInitialFormValues(initialValues)}
            >
              <AddBox /> New Booking
            </Button>
          </Grid>
        </Grid>

        <Grid item>
          {!!initialFormValues && (
            <BookingForm
              isNew={true}
              mosaicPane={document.getElementById(mosaicPanel)}
              booking={initialFormValues}
              closeForm={() => setInitialFormValues(null)}
            />
          )}
        </Grid>

        <Grid item>
          <FilterSearchTable
            id={id}
            path={path}
            className="booking_display_table"
            events={tableData}
            parentId={mosaicPanel}
            uniqueKey={"_id"}
            allowMultiFilter={true}
            selectModeSingle={true}
            hideFilter={false}
            hideFocusSelected={true}
            hideSelectionCheckboxes={false}
            selectUsingCheckboxesOnly={true}
            stickyHeader={false}
            maxTableHeight={tableMaxHeight}
          />
        </Grid>
      </Grid>
    </OCManageBookings>
  );
};
